import { IconButton as ChakraIconButton } from '@chakra-ui/react';
import { forwardRef } from 'react';

import { IconButtonDefaultProps, type IconButtonProps } from './IconButton.types';

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({ variant, ...props }, ref) => {
  return (
    <ChakraIconButton
      ref={ref}
      variant={variant}
      {...(variant === 'outline' && { bg: { base: 'white', _dark: 'gray.800' } })}
      {...props}
    />
  );
});

IconButton.displayName = 'IconButton';
IconButton.defaultProps = IconButtonDefaultProps;

export { IconButton };
